import {ActivatedRoute, Router} from '@angular/router';
import {environment} from "../../../environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {firstValueFrom, Observable} from 'rxjs';
import {BroadcasterService} from "../broadcaster.service";
const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json'
});

@Injectable({
    providedIn: 'root'
})
export class ProcessAbbyyService {

    constructor(private broadcaster: BroadcasterService, private http: HttpClient, private router: Router, private route: ActivatedRoute) {

    }
  async getFormDetails(id: any): Promise<any>{
    try {
      const res = await firstValueFrom(this.http.post<any>(environment.apiUrl + 'de/getAbbyyForm', {sid: localStorage.getItem('token'), afid: id}));
      return res;
    } catch(e) {
      throw e;
    }
  }
    // public getFormDetails(id: any): Observable<any> {
    //     return new Observable<any>(observer => {
    //         this.http.post<any>(environment.apiUrl + 'de/getAbbyyForm',
    //             {sid: localStorage.getItem('token'), afid: id})
    //             .subscribe((res: any) => {
    //                 observer.next(res);
    //             }, err => {
    //                 observer.error(err);
    //             });
    //     });
    // }
  async markAsError(afId, status, patient): Promise<any>{
    try {
      const res = await firstValueFrom(this.http.post<any>(environment.apiUrl + 'de/markAsError', {sid: localStorage.getItem('token'), afId, status, patient}));
      return res;
    } catch(e) {
      throw e;
    }
  }
    // public markAsError(afId, status, patient): Observable<any> {
    //     return new Observable<any>(observer => {
    //         this.http.post<any>(environment.apiUrl + 'de/markAsError',
    //             {sid: localStorage.getItem('token'), afId, status, patient})
    //             .subscribe((res: any) => {
    //                 observer.next(res);
    //             }, err => {
    //                 observer.error(err);
    //             });
    //     });
    // }
  async processAd(afId, patient, adData, status, formType, agentForm, mrn, rejectForm, nullify,
                  isIehpPatient, lang, additionalForms, iehpHcpoa): Promise<any>{
    try {
      const res = await firstValueFrom(this.http.post<any>(environment.apiUrl + 'de/processAdvanceDirective', {sid: localStorage.getItem('token'), afId, patient, adData, status, formType, agentForm, mrn, rejectForm,
        nullify, is_iehp_patient: isIehpPatient, lang, additional_forms: additionalForms, iehp_hcpoa: iehpHcpoa}));
      return res;
    } catch(e) {
      throw e;
    }
  }
    // public processAd(afId, patient, adData, status, formType, agentForm, mrn, rejectForm, nullify,
    //                  isIehpPatient, lang, additionalForms, iehpHcpoa): Observable<any> {
    //     return new Observable<any>(observer => {
    //         this.http.post<any>(environment.apiUrl + 'de/processAdvanceDirective',
    //             {sid: localStorage.getItem('token'), afId, patient, adData, status, formType, agentForm, mrn, rejectForm,
    //                 nullify, is_iehp_patient: isIehpPatient, lang, additional_forms: additionalForms, iehp_hcpoa: iehpHcpoa})
    //             .subscribe((res: any) => {
    //                 observer.next(res);
    //             }, err => {
    //                 observer.error(err);
    //             });
    //     });
    // }
  async publishForm(afId, patient, polstData, status, nullify, lang): Promise<any>{
    try {
      const res = await firstValueFrom(this.http.post<any>(environment.apiUrl + 'de/publishAbbyyForm',
        {sid: localStorage.getItem('token'), afId, patient, polstData, status, nullify, lang}));
      return res;
    } catch(e) {
      throw e;
    }
  }
    // public publishForm(afId, patient, polstData, status, nullify, lang): Observable<any> {
    //     return new Observable<any>(observer => {
    //         this.http.post<any>(environment.apiUrl + 'de/publishAbbyyForm',
    //             {sid: localStorage.getItem('token'), afId, patient, polstData, status, nullify, lang})
    //             .subscribe((res: any) => {
    //                 observer.next(res);
    //             }, err => {
    //                 observer.error(err);
    //             });
    //     });
    // }
  async rejectForm(afId, patient, rejectReasons, polstData, nullify, lang) {
    try {
      const res = await firstValueFrom(this.http.post<any>(environment.apiUrl + 'de/rejectAbbyyForm',
        {sid: localStorage.getItem('token'), afId, patient, rejectForm: rejectReasons, polstData, nullify, lang}));
      return res;
    } catch(e) {
      throw e;
    }
  }
  async getOriginalDocument(afId:any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json', 'Accept': 'application/json'});
    try {
      const res = await firstValueFrom(this.http.post<any>(environment.apiUrl + 'de/downloadOriginal', {sid: localStorage.getItem('token'), afId}, {headers, responseType: 'blob' as 'json' }));
      return res;
    } catch(e) {
      throw e;
    }
  }
  async resetBatchToForm(afId) {
    try {
      const res = await firstValueFrom(this.http.post<any>(environment.apiUrl + 'de/undoClaudeBatchClassification', {sid: localStorage.getItem('token'), afId}));
      return res;
    } catch(e) {
      throw e;
    }
  }
  public manipulateDocument(type, formId, pagesToRemove, movePages, rotateRange, rotateType): Observable<any> {
    return new Observable<any>(observer => {
      this.http.post<any>(environment.apiUrl + 'de/manipulateDocument',
        {sid: localStorage.getItem('token'), type, afId: formId, pgs_to_delete: pagesToRemove,
          move_pages: movePages, pgs_to_rotate: rotateRange, rotate_type: rotateType})
        .subscribe((res: any) => {
          observer.next(res);
        }, err => {
          console.log(err);
          observer.error(err);
        });
    });
  }
  public downloadPdfVersion(id, versionId): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });
    return new Observable<any>(observer => {
      this.http.post<any>(environment.apiUrl + 'de/downloadPdfVersion',
        {sid: localStorage.getItem('token'), afid: id, version_id: versionId},
        {headers, responseType: 'blob' as 'json' })
        .subscribe((res: any) => {
          observer.next(res);
        }, err => {
          observer.error(err);
        });
    });
  }
  public resetDocument(formId) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });
    return new Observable<any>(observer => {
      this.http.post<any>(environment.apiUrl + 'de/resetDocument',
        {sid: localStorage.getItem('token'), afId: formId},
        {headers, responseType: 'blob' as 'json' })
        .subscribe((res: any) => {
          observer.next(res);
        }, err => {
          console.log(err);
          observer.error(err);
        });
    });
  }
}
